<div id="dark">
  <div class="header-row"></div>

  <div class="autocomplete" *ngIf="!isCompanySearch">


    <div
      *ngIf="
        (isFavClients ? favClients : clientList)?.length &&
        (searchValue || isFavClients)
      "
      class="suggestion-list"
    >
      <div
        *ngFor="let record of isFavClients ? favClients : clientList"
        (click)="userChange(record)"
      >
        <div
          class="row align-items-center justify-content-between mx-1 px-0 clickable search-result-div"
          *ngIf="isFund? record.accountType == 3 :(record.accountType == 0 || record.accountType == 1001)"
        >
          <div class="d-flex align-items-center">
            <div class="IPO-card-logo-container d-flex align-item-center">
              <img
                class="avatar"
                src="assets/img/male-fund-avatar.svg"
                alt=""
              />
            </div>
            <div class="mx-3 text-start">
              <div class="text-color-theme font-600">
                ({{ record.relationCode }})
              </div>
              <div class="dimmed-Title font-small">
                {{
                  translate.currentLang == "en"
                    ? record.clientNameEn
                    : record.clientNameAr
                }}
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>

  <div mat-dialog-content *ngIf="isCompanySearch">
    <div [attr.dir]="lang == 'ar' ? 'rtl' : 'ltr'">
    <div class="container modal-container px-3 pb-3 pt-0">
    <div
    class="container modal-container d-flex flex-column justify-content-start px-3 pb-3 pt-0">
    <div class="d-flex flex-wrap mt-2 mb-4">
      <div class="content-w mx-2 d-flex flex-column align-items-start">
        <div class="d-flex">
          <span class=" mx-1 font-600 company-text-title">
            {{ "choose-company" | translate }}
          </span>
        </div>
      </div>
    </div>
  <div class="autocomplete" *ngIf="isCompanySearch">
    <div class="search-bar">
      <input
        type="text"
        [(ngModel)]="searchValue"
        class="form-control"
        placeholder="{{ 'search' | translate }}"
        (keyup)="credentialsSearchFilter($event)"
      />
      <button
        class="clearButton"
        *ngIf="searchValue"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        (click)="searchValue = ''"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div *ngIf="records.length > 0 && searchValue" class="suggestion-list">
      <div
        *ngFor="let record of records"
        class="d-flex  flex-xl-row flex-lg-row flex-md-row flex-sm-row  flex-column justify-content-between align-utems-center search-result-div"
        (click)="onCompanySelect(record)"
        >
        <div class="w-100 d-flex align-item-center justify-content-between">
          <div
            
            class="company-div"
          >
            {{
              translate.currentLang == "en" ? record.ENG_NAME : record.ARB_NAME
            }}
          </div>
          <div
            (click)="onCompanySelect(record)"
            class="p-2 company-price-div"
            
          >
            {{ record.LAST_TRADE_PRICE | number : "1.2-2" }}
          </div>
        </div>
        <div class="my-class-container">


        </div>
      </div>
    </div>
  </div>
  </div>
</div>
</div>
</div>
</div>
